import {
  APICurrentUser,
  APIPresentationAssetAttributes,
} from '@ardoq/api-types';
import { userOperations } from '@ardoq/core';
import { AppModules } from 'appContainer/types';
import { showPresentationEditor } from 'showPresentationEditor';
import { dispatchAction } from '@ardoq/rxbeach';
import { togglePresentationEditor } from 'appContainer/actions';
import { trackClickedToolbarButton } from 'tracking/events/clicks';

export const getCanAccessPresentationEditor = (
  currentUser: APICurrentUser | null
): boolean =>
  currentUser !== null && userOperations.hasWriterRolePlus(currentUser);

type TogglePresentationEditorArgs = {
  presentation: APIPresentationAssetAttributes | undefined;
  isOpen: boolean;
  selectedModule: AppModules;
};

export const makeTogglePresentationEditorHandler =
  ({
    presentation,
    isOpen,
    selectedModule,
  }: TogglePresentationEditorArgs): VoidFunction =>
  () => {
    if (isOpen) {
      trackClickedToolbarButton('Presentation editor');
      dispatchAction(togglePresentationEditor({ shouldShow: false }));
      return;
    }
    showPresentationEditor({
      contextPresentationId: presentation?._id,
      selectedModule,
      shouldShow: true,
    });
  };
